// @flow
import { combineReducers } from 'redux';

import * as types from '../types/drivers';
import * as common from './common';
import type { ERROR_TYPE } from '../types/common';
import type { DRIVER_TYPE } from '../types/drivers';

export type DriversState = {
  byId: { [number]: DRIVER_TYPE },
  fetching: Array<number>,
  errors: { [number]: ERROR_TYPE }
};

const byId = common.byId({
  added: [types.DRIVER_FETCH_SUCCEED],
});

const fetching = common.fetching({
  started: [types.DRIVER_FETCH_STARTED],
  failed: [types.DRIVER_FETCH_FAILED],
  succeed: [types.DRIVER_FETCH_SUCCEED],
});

const errors = common.errors({
  populate: [types.DRIVER_FETCH_FAILED],
  clear: [types.DRIVER_FETCH_SUCCEED],
});

const drivers = combineReducers({
  byId,
  fetching,
  errors,
});

export default drivers;

export const getDriver = (state: DriversState, id: number): DRIVER_TYPE => state.byId[id];
export const isDriverFetching = (
  state: DriversState,
  id: number,
): boolean => state.fetching.includes(id);
export const getDriverError = (state: DriversState, id: number): ERROR_TYPE => state.errors[id];



// WEBPACK FOOTER //
// ./src/scripts/reducers/drivers.js